package com.futurions.portfolio.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.css.functions.dropShadow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backdropFilter
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.A

@Composable
fun ResumeSection() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 80.px, bottom = 80.px)
            .id("resume"),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .maxWidth(900.px)
                .padding(40.px)
                .backgroundColor(rgba(255, 255, 255, 0.05))
                .backdropFilter(blur(18.px))
                .borderRadius(24.px)
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 4.px,
                    blurRadius = 26.px,
                    spreadRadius = 8.px,
                    color = rgba(0, 0, 0, 0.35)
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {

            // --- TITLE ---
            SpanText(
                text = "📄 Resume",
                modifier = Modifier
                    .fontSize(30.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Color.white)
                    .padding(bottom = 16.px)
            )

            // --- DESCRIPTION ---
            SpanText(
                text = "Here is my latest resume showcasing my experience in Android development, Kotlin Multiplatform (KMP), UI/UX design, and game development. You can download it below.",
                modifier = Modifier
                    .fontSize(18.px)
                    .lineHeight(28.px)
                    .color(rgb(220, 220, 220))
                    .textAlign(TextAlign.Center)
                    .maxWidth(700.px)
                    .padding(bottom = 28.px)
            )

            // --- DOWNLOAD BUTTON ---
            ResumeButton(
                label = "Download Resume (PDF)",
                url = "resume1.pdf"
            )
        }
    }
}

@Composable
fun ResumeButton(label: String, url: String) {
    A(
        href = url,
        attrs = {
            attr("download", "")
        }
    ) {
        Box(
            modifier = Modifier
                .padding(topBottom = 12.px, leftRight = 24.px)
                .backgroundColor(rgba(0, 200, 255, 0.2))
                .borderRadius(16.px)
                .border(1.5.px, color = rgba(0, 255, 255, 0.5))
                .cursor(Cursor.Pointer)
                .transition(Transition.of("transform", 0.3.s))
        ) {
            SpanText(
                text = label,
                modifier = Modifier
                    .fontSize(18.px)
                    .color(Color.white)
            )
        }
    }
}
